
import Vue from 'vue';

import { mapState, mapActions } from 'pinia';
import { useStore as useProductStore } from '@/stores/product';

import ProductNotPrintableNotification from './ProductNotPrintableNotification.vue';

export default Vue.extend({
  name: 'ProductNotPrintableMonitor',

  components: { ProductNotPrintableNotification },

  computed: {
    ...mapState(useProductStore, ['data', 'isProductPrintable']),

    productIsPrintable() {
      const { name, readyToPrint } = this.data;

      this.setIsProductPrintable(readyToPrint);

      return {
        productName: name,
      };
    },
  },

  methods: {
    ...mapActions(useProductStore, ['setIsProductPrintable']),
  },
});
